export const ARCHIEVED_REASON = [
  "Lost to another",
  "Self Move",
  "Bad Review",
  "Went with recommendation",
  "Refused Hire",
  "Fallen Thro",
  "Duplicate",
  "Fully Booked",
  "T&Cs",
  "Time Waster",
  "Re-survey",
  "Too small",
  "Wrong Number / Email",
  "Too expensive",
  "All sorted",
  "Wanted Physical",
  "Got enough Quotes",
  "Just browsing",
  "Renew Opportunity",
  "No thank / Not interested",
  "Only wants local",
  "Already moved",
  "Will contact us when ready",
  "Passed move date",
  "No response",
  "Debtor",
  "Entered in error",
  "Drop Out",
  "Dispute",
  "Volume Under",
  "Late",
  "Breakages",
  "Pack Incomplete",
  "Missing Items",
  "Dismantle / Reassemble",
  "Understaffed",
  "Wrong Wages",
  "Access Issues",
];

export const PROFESSIONAL_ARCHIEVED = [
  "Using another",
  "Self Move",
  "Bad Review",
  "Refused Hire",
  "Fallen Thro`",
  "Duplicate",
  "Fully Booked",
  "T&Cs",
  "Time Waster",
  "Re-survey",
  "Too small",
  "Too expensive",
  "All sorted",
  "Wanted Physical",
  "Got enough Quotes",
  "Just browsing",
  "Renew Opportunity",
  "No thank / Not interested",
  "Only wants local",
  "Already moved",
  "Will contact us when ready",
  "Passed move date",
  "No response",
  "Entered in error",
  "Drop Out'",
  "Reclaim",
  "Not Specific",
  "International",
  "Not Moving"
];

export const PROFESSIONAL_LOST = [
  "Using another",
  "Too expensive",
  "Stopped responding",
  "All Sorted",
  "Passed move date",
  "Fully booked",
  "Refused Hire charge",
  "Not Specific",
  "International",
  "Not Moving"
];

export const SURVEY_REASON = ["Wants physical survey"];

export const QUOTE_REASON = ["Requote"];
